import _ from 'lodash'
import { FC } from 'react'
import { connectCurrentRefinements } from 'react-instantsearch-dom'

interface props {
  items: any[]
  hideIfZero: boolean
}
const CurrentRefinements: FC<props> = ({ items, hideIfZero = false }) => {
  //Need to figure out why items return same item four times
  //Use lodash to get unique result for now
  const uniqueCurrentRefinmentsObject = _.uniqBy(items, 'id')
  let numberOfFilters = 0
  uniqueCurrentRefinmentsObject.forEach((element) => {
    numberOfFilters += element.items.length
  })
  if (hideIfZero && items.length === 0) return <></>
  return (
    <>
      <div className="mr-3 flex items-center justify-center rounded-full text-white text-label h-6 w-6 bg-brand-chrome">
        {numberOfFilters}
      </div>
    </>
  )
}

const NoOfFilters = connectCurrentRefinements(CurrentRefinements)
export default NoOfFilters
